export class TypeCodeHelper {
    static Shipment = class {
        static NORMAL = 1;
    };
    static Request = class {
        static NORMAL = 1;
        static TASETCO = 2;
    };
}